'use strict';

import * as _ from 'lodash';
import { module } from '../app';
import * as authorizationConstants from '../constants/authorizationConstants';

module.service('authService', [
  '$state', 'localStorage', '$q', 'Account', 'signalrService', 'techpadInitialConfigProvider', '$ionicLoading', '$rootScope',
  function ($state, localStorage, $q, Account, signalrService, techpadInitialConfigProvider, $ionicLoading, $rootScope) {
    let userLoginKey = 'UserLogin';
    let magViewUrlKey = 'MagViewUrl';
    let magViewAuthTokenKey = 'MagViewAuthToken';
    let magviewDeviceId = 'MagViewDeviceId';
    let magViewUserName = 'MagViewUserName';
    let magViewRoles = 'magViewRoles';
    let magViewPermissions = 'magViewPermissions';

    this.authorizationConstants = authorizationConstants;

    let auth = {
      loggedIn: !!localStorage.get(userLoginKey),
      checkIfLoggedIn: function(){
        return !!localStorage.get(userLoginKey);
      },
      _currentMagViewUrl: null,
      currentMagViewUrl: function () {
        if (auth._currentMagViewUrl)
          return auth._currentMagViewUrl;

        auth._currentMagViewUrl = localStorage.get(magViewUrlKey);
        return auth._currentMagViewUrl;
      },

      getTechpadDiagramHeaders: function () {
        let headers = {};
        headers[authorizationConstants.constants.techpadDiagram.requestHeaderKeyName] = authorizationConstants.constants.techpadDiagram.requestHeaderKeyValue;
        return headers;
      },

      changeTechnologistPassword: async function (username, newPassword, portal, authToken) {
        let portalUrl = _.trim(portal.url, '/');
        await Account.changeTechnologistPassword(username, newPassword, portalUrl, authToken);
      },

      checkSessionValid: async function(){
        const currentMagviewUrl = auth.currentMagViewUrl();
        return await Account.checkSessionValid(currentMagviewUrl);
      },

      login: function (username, password, portal, onTechnologistPasswordChange) {
        $rootScope.hideContent = false;
        let portalUrl = _.trim(portal.url, '/');

        return Account.login(portalUrl, username, password)
          .then(async function (resp) {
            if (!resp.data.Success) {
              return $q.reject(resp);
            }

            if (resp.data.IsForcePasswordChange && onTechnologistPasswordChange && typeof onTechnologistPasswordChange === 'function') {
              await onTechnologistPasswordChange({ username, password, portal, authToken: resp.data.AuthToken });
            }

            auth.loggedIn = true;

            localStorage.set(magViewAuthTokenKey, resp.data.AuthToken);
            localStorage.set(userLoginKey, resp.data.Login || username);
            localStorage.set(magViewUrlKey, portalUrl);
            localStorage.set(magViewUserName, resp.data.Name);
            localStorage.set(magViewRoles, resp.data.Roles);
            localStorage.setObject(magViewPermissions, resp.data.Permissions);

            Account.setToken(auth.getAuthToken());
            auth.registerDevice();
            signalrService.connect();
          });
      },

      logout: function () {
        $ionicLoading.show({ template: 'Logging out...' });
        try {
          auth.unregisterDevice();

          signalrService.disconnect();

          auth.loggedIn = false;
          auth._currentMagViewUrl = null;
          
          $rootScope.hideContent = true;
          localStorage.cleanUpEntireStorageExceptHospitalCode();

          Account.setToken(auth.getAuthToken());
          
          $state.go('login');
        } catch (error) {
          console.error();
        } finally {
          $ionicLoading.hide();
        }
      },

      logoutOnSessionExpired: function(){
        $ionicLoading.show({ template: 'Logging out...' });
        try {
          signalrService.disconnect();

          auth.loggedIn = false;
          auth._currentMagViewUrl = null;
          
          $rootScope.hideContent = true;
          localStorage.cleanUpEntireStorageExceptHospitalCode();
          
          Account.setToken(auth.getAuthToken());

          window.location.href = '/';
        } catch (error) {
          console.error();
        } finally {
          $ionicLoading.hide();
        }
      },

      checkPortalUrl: function () {
        if (!auth.loggedIn) {
          return;
        }

        Account.setToken(auth.getAuthToken());
        signalrService.connect();
      },

      getAuthToken: function () {
        return localStorage.get(magViewAuthTokenKey);
      },

      getUserName: function () {
        return localStorage.get(userLoginKey);
      },

      getDisplayName: function () {
        return localStorage.get(magViewUserName);
      },

      getRoles: function () {
        return localStorage.get(magViewRoles);
      },

      getPermissions: function () {
        return localStorage.get(magViewPermissions);
      },

      refreshPermissions: function () {
        if (!auth.loggedIn) {
          return $q.resolve();
        }

        // On failure the stored permissions are left untouched; the caller decides how to notify.
        return Account.getPermissions(auth.currentMagViewUrl())
          .then(function (resp) {
            if (resp && resp.data) {
              localStorage.setObject(magViewPermissions, resp.data);
            }
          });
      },

      isRadiologist: function () {
        const roles = localStorage.get(magViewRoles);
        const rolesArray = _.split(roles, ',');
        return _.some(rolesArray, role => role === 'Radiologist');
      },

      registerDevice: function () {
        if (!!localStorage.get(magviewDeviceId))
          Account.registerDevice(auth.currentMagViewUrl(), localStorage.get(magviewDeviceId));
      },

      unregisterDevice: function () {
        const currentMagviewUrl = auth.currentMagViewUrl();
        const deviceId = localStorage.get(magviewDeviceId);
        if (!currentMagviewUrl) {
          return;
        }
        const authToken = auth.getAuthToken();
        Account.unregisterDevice(currentMagviewUrl, deviceId, authToken);
        localStorage.set(magviewDeviceId, '');
      },

      getPortalSecurityToken: function () {
        const securityToken = Account.getPortalSecurityToken(auth.currentMagViewUrl());
        
        return securityToken;
      },
      _ensureMagviewPortal: null,
      ensureMagviewPortal: function () {
        return auth._ensureMagviewPortal;
      },
      getPasswordRequirements: async function (portal) {
        let portalUrl = _.trim(portal.url, '/');
        const passwordRequirements = await Account.getPasswordRequirements(portalUrl);

        return passwordRequirements;
      }
    };

    let defer = $q.defer();
    auth._ensureMagviewPortal = defer.promise;

    if (techpadInitialConfigProvider.getMagviewUrl && _.isFunction(techpadInitialConfigProvider.getMagviewUrl)) {
      let url = techpadInitialConfigProvider.getMagviewUrl();
      if (url) {
        if (!_.startsWith(url, 'http://') && !_.startsWith(url, 'https://') && !_.startsWith(url, '//')) {
          url = '//' + url;
        }
        auth._currentMagViewUrl = url;
      }
    } 

    defer.resolve();

    return auth;
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/services/auth.js